import {Component, ChangeDetectionStrategy, inject, signal} from '@angular/core';
import { HeightService} from './height.service';

@Component({
  selector: 'app-height',
  imports: [],
  templateUrl: './height.html',
  styleUrl: './height.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class Height {
  protected heightService = inject(HeightService);

  protected onHeightChange(event: Event): void {
    const value = Number((event.target as HTMLSelectElement).value);
    this.heightService.setSelectedHeight(value);
  }

  selectHeight(height: number) {
    this.heightService.setSelectedHeight(height);
  }
}
